module.exports = __webpack_public_path__ + "static/media/special-adventour.51371ac8.png";